import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import { adjective as proAdjective } from "@language/provider";
import { adjective as clientAdjective } from "@language/client";

const ProStats = () => {
	const classes = useStyles("Pro");

	const { fact_1, fact_2, fact_3, fact_4 } = useConstants("ProBannerViewModel");

	return (
		<Box bgcolor={"rgb(217 245 255)"}>
			<Box p={"80px 16px 120px"}>
				<Container maxWidth={false} className={classes.proContainer}>
					<h2 className={classes.joinH2}>
						{proAdjective.plural.ucFirst()} like you are in high demand
					</h2>
					<Grid container spacing={6}>
						<Grid item xs={12} sm={6} md={4}>
							<Box
								display={"flex"}
								flexDirection={"column"}
								bgcolor={"#FFF"}
								borderRadius={12}
								p={8}
								height={"100%"}
							>
								<Box
									fontSize={{ xs: 42, md: 46, lg: 62 }}
									mb={2}
									fontWeight={600}
									lineHeight={1.3}
								>
									{fact_1}
								</Box>
								<Box mb={12}>{clientAdjective.plural} helped</Box>
								<Box fontSize={12} color={"grey.700"} mt={"auto"}>
									as of February 18, 2023
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							<Box
								display={"flex"}
								flexDirection={"column"}
								bgcolor={"#FFF"}
								borderRadius={12}
								p={8}
								height={"100%"}
							>
								<Box
									fontSize={{ xs: 42, md: 46, lg: 62 }}
									mb={2}
									fontWeight={600}
									lineHeight={1.3}
								>
									{fact_2}
								</Box>
								<Box mb={12}>active {proAdjective.plural}</Box>
								<Box fontSize={12} color={"grey.700"} mt={"auto"}>
									as of February 18, 2023
								</Box>
							</Box>
						</Grid>
						{/* <Grid item xs={12} sm={6} md={4}>
							<Box
								display={"flex"}
								flexDirection={"column"}
								bgcolor={"#FFF"}
								borderRadius={12}
								p={8}
								height={"100%"}
							>
								<Box
									fontSize={{ xs: 42, md: 46, lg: 62 }}
									mb={2}
									fontWeight={600}
									lineHeight={1.3}
								>
									250+
								</Box>
								<Box mb={12}>subjects with active tutors</Box>
								<Box fontSize={12} color={"grey.700"} mt={"auto"}>
									as of February 18, 2023
								</Box>
							</Box>
						</Grid> */}

						{fact_4 && (
							<Grid item xs={12} sm={6} md={4}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									bgcolor={"#FFF"}
									borderRadius={12}
									p={8}
									height={"100%"}
								>
									<Box
										fontSize={{ xs: 42, md: 46, lg: 62 }}
										mb={2}
										fontWeight={600}
										lineHeight={1.3}
									>
										{fact_4}
									</Box>
									<Box mb={12}>
										est. earnings by {proAdjective.plural}, all-time
									</Box>
									<Box fontSize={12} color={"grey.700"} mt={"auto"}>
										as of February 18, 2023
									</Box>
								</Box>
							</Grid>
						)}
					</Grid>
				</Container>
			</Box>
		</Box>
	);
};

ProStats.propTypes = {};
export default ProStats;
